import {
    getSubscription,
    listSubscriptions
} from './queries';
import {
    createSubscription,
    deleteSubscription,
    updateSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateSubscription,
    DeleteSubscription,
    GetSubscription,
    ListSubscriptions,
    UpdateSubscription
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (filter?: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListSubscriptions>>({
                                                                               query: listSubscriptions,
                                                                               variables: {...(filter ? {filter} : {}), limit, nextToken},
                                                                           });
    return response.data?.listSubscriptions;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetSubscription>>({
                                                                             query: getSubscription,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getSubscription;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateSubscription>>({
                                                                                query: createSubscription,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createSubscription;
};

// FNP-918: takes an already-WHITELISTED payload (§6).
//
// It used to blocklist by `delete`-ing `created`/`updated` off a spread of the
// record, which sent every other undeclared field straight at
// UpdateSubscriptionInput. Whitelisting is the caller's job now — see
// `toInput` in hooks/useSubscription.ts — so this layer just posts what it is
// given and no field can drift in unnoticed.
export const update = async (_id: string, payload: object) => {
    const response = await client.graphql<GraphQLQuery<UpdateSubscription>>({
                                                                                query: (updateSubscription),
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.updateSubscription;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteSubscription>>({
                                                                                query: (deleteSubscription),
                                                                                variables: {input: {id: id}},
                                                                            });
    return response.data?.deleteSubscription;
};
